
<template>
  <div class="swiper-container">
    <swiper :options="swiperOptions" ref="mySwiper">
      <swiper-slide v-for="(item,index) in slides" :key="index">
        <div style="width:100%;height: 100%;border:2px solid red;color: white;">{{item.title}}</div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// // import 'swiper/css/swiper.css'
// import 'swiper/swiper.css'
// Vue.use(VueAwesomeSwiper)


//   import { Swiper, SwiperSlide } from 'swiper/vue';
//   import { Swiper, SwiperSlide } from 'swiper/swiper-vue';

  // Import Swiper styles
//   import 'swiper/css';
//   import 'swiper/swiper.css'

export default {
    // components: {
    //   Swiper,
    //   SwiperSlide,
    // },
  data() {
    return {
      slides: [
        { image: 'https://picsum.photos/800/400?1', title: 'Slide 1' },
        { image: 'https://picsum.photos/800/400?2', title: 'Slide 2' }
      ],
      swiperOptions: {
        loop: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 400px;
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
